import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useCreateChannelConnection } from '@/lib/api/channel-connections';
import { ApiError } from '@/lib/api/client';
import { ConnectionForm } from '@/routes/gateway/connection-form';

export function ConnectionNewPage() {
  const createConnection = useCreateChannelConnection();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">New channel connection</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          One external account (e.g. an Instagram business account) and its credentials.
        </p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Connection</CardTitle>
          <CardDescription>Secrets are stored encrypted and never shown again.</CardDescription>
        </CardHeader>
        <CardContent>
          <ConnectionForm
            submitting={createConnection.isPending}
            submitLabel="Create connection"
            error={error}
            onCancel={() => void navigate({ to: '/gateway/connections' })}
            onSubmit={(input) => {
              setError(null);
              createConnection.mutate(input, {
                onSuccess: (connection) =>
                  void navigate({
                    to: '/gateway/connections/$connectionId',
                    params: { connectionId: connection.id },
                  }),
                onError: (caught) =>
                  setError(
                    caught instanceof ApiError
                      ? caught.message
                      : 'Could not create the connection.',
                  ),
              });
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
